import React from "react";
import logo from "../shadow-logo.png";

import RoundButton from "./RoundButton";
import Button from "./Button";

import { Link } from "@reach/router";

import ReactSession from "react-client-session/dist/ReactSession";
import GoogleButton from "react-google-login";
import axios from "axios";

const Header = (props) => {
  const user = ReactSession.get("username");
  const loggedIn = user !== undefined;
  const resGoogle = async (googleRes) => {
    axios.post("/api/verifylogin", { tokenId: googleRes.tokenId }).then((res) => {
      ReactSession.set("userId", res.data.googleId);
      ReactSession.set("username", googleRes.profileObj.name);
      ReactSession.set("userImg", res.data.img)
      window.location.reload(false);
    });
  };
  return (
    <div class="relative p-2 flex w-full select-none z-10">
      <Link to="/">
        <img src={logo} alt="stickman" className="h-24 m-2 mr-4 my-auto"></img>
      </Link>
      <RoundButton text="1w" />
      <RoundButton text="2w" />
      <RoundButton text="3w" />
      <RoundButton text="4w" />
      <RoundButton text="5w" />
      {/* <RoundButton text="1e" />
      <RoundButton text="2e" />
      <RoundButton text="3e" />
      <RoundButton text="4e" />
      <RoundButton text="5e" /> */}

      {loggedIn ? (
        <div class="flex ml-auto pr-4">
          <div class="my-auto text-white font-bold text-shadow-sm mx-4 bg-red-600 bg-opacity-80 px-4 py-1 rounded">
            Welcome, {user}
          </div>
          <Button text="Gallery" to="/gallery" />
          <Button text="Logout" to="/logout" />
        </div>
      ) : (
        <div class="flex ml-auto pr-4">
          <Button text="Gallery" to="/gallery" />
          <GoogleButton
            render={(renderProps) => (
              <button
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                className="inline-flex my-auto font-bold rounded-full px-6 pl-4 h-11 mx-2 text-center bg-white bg-opacity-90 shadow-lg"
              >
                <img
                  src="https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA"
                  alt="google"
                  className="h-6 pr-2 inline-block my-auto"
                />
                <div className="my-auto mx-auto">
                  <span class="my-auto text-gray-600 pr-3 pl-2">
                    Sign in
                  </span>
                </div>
              </button>
            )}
            clientId="160864591994-bucenj0muq8250qb7701v5atqsactgo5.apps.googleusercontent.com"
            buttonText="Sign in with Google"
            onSuccess={resGoogle}
            onFailure={resGoogle}
            cookiePolicy={"single_host_origin"}
          ></GoogleButton>
        </div>
      )}
    </div>
  );
};

export default Header;
